import { render, staticRenderFns } from "./formInformacionEmbarque.vue?vue&type=template&id=3b80f7c5"
import script from "./formInformacionEmbarque.vue?vue&type=script&lang=js"
export * from "./formInformacionEmbarque.vue?vue&type=script&lang=js"
import style0 from "./formInformacionEmbarque.vue?vue&type=style&index=0&id=3b80f7c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports